import type { SVGProps } from 'react';

interface EventIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export function EventIcon({ className, ...props }: EventIconProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="4.5 4.5 15.0 15.0"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path d="M18.2217 16.917C18.6359 16.917 18.9717 17.2528 18.9717 17.667C18.9715 18.0811 18.6358 18.417 18.2217 18.417H5.77734C5.36344 18.4168 5.02752 18.0809 5.02734 17.667C5.02734 17.2529 5.36333 16.9172 5.77734 16.917H18.2217ZM12 5.25C13.2733 5.25006 14.3057 6.28238 14.3057 7.55566V7.94531C17.0387 8.89851 19 11.4976 19 14.5557V15.333C18.9999 15.7357 18.6939 16.0676 18.3018 16.1074L18.2227 16.1113H5.77734L5.69824 16.1074C5.30607 16.0676 5.00006 15.7357 5 15.333V14.5557C5 11.4976 6.9613 8.89851 9.69434 7.94531V7.55566C9.69434 6.28235 10.7267 5.25002 12 5.25ZM12 9.05566C8.96243 9.05566 6.5 11.5181 6.5 14.5557V14.6113H17.5V14.5557C17.5 11.5181 15.0376 9.05566 12 9.05566ZM12 6.75C11.5718 6.75002 11.222 7.08413 11.1963 7.50586H12.8037C12.778 7.08415 12.4282 6.75006 12 6.75Z" fill="currentColor"/>
    </svg>
  );
}
